<div *ngIf="isLoading" class="loading-overlay">
  <mat-progress-bar color="accent" mode="indeterminate"></mat-progress-bar>
</div>

<div class="container py-3" style="max-width: 1020px">
  <div class="row">
    <div class="col-md-8 mb-3">
      <mat-card class="p-4" style="max-width: 650px">
        <mat-card-title
          *ngIf="true"
          mat-dialog-title
          class="d-flex align-items-center mb-0"
        >
          <mat-icon class="mr-2">chair</mat-icon>
          &nbsp;
          <div *ngIf="!isEdit">
            {{ 'rooms.add-edit.add-title' | translate }}
          </div>
          <div *ngIf="isEdit">
            {{ 'rooms.add-edit.edit-title' | translate }}
          </div>
        </mat-card-title>

        <mat-card-subtitle>
          <div *ngIf="!isEdit">
            {{ 'rooms.add-edit.add-subtitle' | translate }}
          </div>
          <div *ngIf="isEdit">
            {{ 'rooms.add-edit.edit-subtitle' | translate }}
          </div>
        </mat-card-subtitle>

        <mat-divider></mat-divider>

        <mat-card-content>
          <form [formGroup]="addEditRoomsFormGroup">
            <div class="row mt-4">
              <div class="col-md-12">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'rooms.add-edit.form.name' | translate }}
                  </mat-label>
                  <input
                    type="text"
                    matInput
                    formControlName="name"
                    [placeholder]="
                      translate.instant('rooms.add-edit.form.name-placeholder')
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error
                    *ngIf="
                      addEditRoomsFormGroup.get('name').hasError('required') ||
                      addEditRoomsFormGroup.get('name').hasError('whitespace')
                    "
                    >{{
                      'rooms.add-edit.form.required.name' | translate
                    }}</mat-error
                  >
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'rooms.add-edit.form.seating-capacity' | translate }}
                  </mat-label>
                  <input
                    type="number"
                    min="0"
                    matInput
                    formControlName="seatingCapacity"
                    [placeholder]="
                      translate.instant(
                        'rooms.add-edit.form.seating-capacity-placeholder'
                      )
                    "
                    required
                    maxlength="50"
                  />
                  <mat-error>{{
                    'rooms.add-edit.form.required.seating-capacity' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="fill">
                  <mat-label>
                    {{ 'rooms.add-edit.form.description' | translate }}
                  </mat-label>
                  <textarea
                    type="text"
                    matInput
                    formControlName="description"
                    [placeholder]="
                      translate.instant(
                        'rooms.add-edit.form.description-placeholder'
                      )
                    "
                    maxlength="250"
                  ></textarea>
                  <mat-error>{{
                    'rooms.add-edit.form.required.description' | translate
                  }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="fill">
                  <mat-label>Available Amenities</mat-label>
                  <mat-chip-list #chipList aria-label="" style="width: 100%">
                    <mat-chip
                      *ngFor="let fruit of filteredResources"
                      [selectable]="selectable"
                      [removable]="removable"
                      (removed)="remove(fruit)"
                    >
                      {{ fruit }}
                      <mat-icon matChipRemove *ngIf="removable"
                        >cancel</mat-icon
                      >
                    </mat-chip>
                    <input
                      formControlName="availableResources"
                      [matAutocomplete]="auto"
                      [matChipInputFor]="chipList"
                      [matChipInputAddOnBlur]="false"
                      (click)="optionPanelOpen()"
                      [readonly]="isDisableForm"
                    />
                    <button
                      [disabled]="isDisableForm"
                      mat-icon-button
                      (click)="optionPanelOpen()"
                    >
                      <mat-icon matSuffix class="material-icons"
                        >arrow_drop_down</mat-icon
                      >
                    </button>
                  </mat-chip-list>
                  <mat-autocomplete
                    #auto="matAutocomplete"
                    (optionSelected)="selected($event)"
                  >
                    <ng-container *ngIf="!isDisableForm">
                      <mat-option
                        *ngFor="let cover of resources"
                        [value]="cover"
                      >
                        {{ cover }}
                      </mat-option>
                    </ng-container>
                  </mat-autocomplete>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 d-flex justify-content-end">
                <button
                  *ngIf="!isEdit"
                  mat-flat-button
                  color="primary"
                  (click)="onSave()"
                  [disabled]="this.addEditRoomsFormGroup.invalid"
                >
                  {{ 'rooms.add-edit.form.save' | translate }}
                </button>
                <button
                  *ngIf="isEdit"
                  mat-flat-button
                  color="primary"
                  (click)="onUpdate()"
                  [disabled]="this.addEditRoomsFormGroup.invalid"
                >
                  {{ 'rooms.add-edit.form.save' | translate }}
                </button>
              </div>
            </div>
          </form>
        </mat-card-content>
      </mat-card>
    </div>

    <!--Help and Support (START)-->
    <div class="col-md-4 mb-3">
      <mat-card style="height: fit-content">
        <mat-card-header>
          <mat-card-title>
            <h6>
              <mat-icon class="heading-icon mr-2">help</mat-icon>&nbsp;
              {{ 'rooms.add-edit.help-and-support.title' | translate }}
            </h6>
            <p style="font-weight: lighter; font-size: small; color: grey">
              {{ 'rooms.add-edit.help-and-support.subtitle' | translate }}
            </p>
          </mat-card-title>
        </mat-card-header>

        <mat-divider></mat-divider>
        <mat-card-content>
          <div class="mt-2 pt-2">
            <mat-accordion [multi]="true">
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title class="d-flex align-items-center">
                    <mat-icon class="heading-icon mr-2"> chair </mat-icon>
                    {{
                      'rooms.add-edit.help-and-support.card-1.title' | translate
                    }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                {{
                  'rooms.add-edit.help-and-support.card-1.content' | translate
                }}
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <!--Help and Support (END)-->
  </div>
</div>
